<template>
	<div class="wrapper">
		<v-container text-xs-center grid-list-sm>
			<v-layout justify-center row wrap>
				<v-flex xs12 sm12 md3>
					<v-select
						persistent-hint
						hint="Select File Extension"
						color="yellow darken-3"
						:items="fileExtensions"
						label="File Extensions"
						v-model="extension"
					></v-select>
				</v-flex>
				<v-flex xs12 sm12 md3>
					<v-autocomplete
						persistent-hint
						hint="Select Reject Remark"
						color="purple darken-3"
						:items="rejectRemarks"
						label="Reject Remark"
						v-model="remark"
					></v-autocomplete>
					<!-- <v-select
						persistent-hint
						hint="Select Reject Remark"
						color="purple darken-3"
						:items="rejectRemarks"
						label="Reject Remark"
						v-model="remark"
					></v-select>-->
				</v-flex>
				<v-flex xs12 sm12 md4>
					<v-text-field
						persistent-hint
						hint="Enter Text to Filter by"
						color="yellow darken-3"
						label="Filter Text"
						v-model="filterText"
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container text-xs-center grid-list-sm>
			<v-layout justify-center row wrap>
				<v-flex xs6 sm6 md3>
					<v-btn @click="filterStockist" flat color="orange darken-1" large
						>Filter</v-btn
					>
				</v-flex>
				<v-flex xs6 sm6 md3 @click="refreshStockistList">
					<v-btn color="pink" flat>Reset Filter</v-btn>
				</v-flex>
			</v-layout>
		</v-container>
		<code>No. of files: {{ getFileCount }}</code>
		<v-expansion-panel>
			<v-expansion-panel-content
				v-for="item of Object.keys(mailMeta)"
				:key="item"
				:class="{
					'expansion-panel-parent': true,
					'are-all-files-converted': areAllFilesConverted(mailMeta[item]),
					'is-marked-for-conversion': areFilesMarkedForConversion(
						mailMeta[item]
					),
				}"
			>
				<template v-slot:header>
					<div class="font-weight-light pa-2">
						<span class="headline">
							<div class="badge-list-wrapper">
								<div
									v-if="
										highlightedFiles[item] &&
											highlightedFiles[item].allHighlighted
									"
									class="highlight-badge all-highlighted amber lighten-2"
								>
									All Highlighted
								</div>
								<div
									v-else-if="
										highlightedFiles[item] &&
											highlightedFiles[item].someHighlighted
									"
									class="highlight-badge some-highlighted"
								>
									Some Highlighted
								</div>
								<div
									v-if="
										pyHighlightedFiles[item] &&
											pyHighlightedFiles[item].allHighlighted
									"
									class="highlight-badge all-highlighted cyan lighten-2"
								>
									All PY Highlighted
								</div>
								<div
									v-else-if="
										pyHighlightedFiles[item] &&
											pyHighlightedFiles[item].someHighlighted
									"
									class="highlight-badge some-highlighted"
								>
									Some PY Highlighted
								</div>
							</div>
							Stockist Name: -
							{{ mailMeta[item][0] ? mailMeta[item][0].stockistName : '' }}
							<template
								v-if="
									highlightedFiles[item] &&
										(highlightedFiles[item].allHighlighted ||
											highlightedFiles[item].someHighlighted)
								"
							>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn
											v-on="on"
											class="ma-2"
											text
											icon
											@click.stop="
												onUnHighlightAllFilesButtonClick(mailMeta[item])
											"
										>
											<v-icon color="amber lighten-2" large>{{
												highlightedFiles[item].someHighlighted
													? 'mdi-star-half'
													: 'mdi-star'
											}}</v-icon>
										</v-btn>
									</template>
									<span>Unhighlight all files for this STOCKIST</span>
								</v-tooltip>
							</template>
							<template v-else>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn
											v-on="on"
											class="ma-2"
											text
											icon
											@click.stop="
												onHighlightAllFilesButtonClick(mailMeta[item])
											"
										>
											<v-icon color="amber lighten-2" large
												>mdi-star-outline</v-icon
											>
										</v-btn>
									</template>
									<span>Highlight all files for this STOCKIST</span>
								</v-tooltip>
							</template>
							<template
								v-if="
									pyHighlightedFiles[item] &&
										(pyHighlightedFiles[item].allHighlighted ||
											pyHighlightedFiles[item].someHighlighted)
								"
							>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn
											v-on="on"
											class="ma-2"
											text
											icon
											@click.stop="
												onUnHighlightAllFilesButtonClick(
													mailMeta[item],
													'PYHIGHLIGHT'
												)
											"
										>
											<v-icon color="cyan lighten-2" large>{{
												pyHighlightedFiles[item].someHighlighted
													? 'mdi-star-half'
													: 'mdi-star'
											}}</v-icon>
										</v-btn>
									</template>
									<span>Unhighlight all files for this STOCKIST</span>
								</v-tooltip>
							</template>
							<template v-else>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-btn
											v-on="on"
											class="ma-2"
											text
											icon
											@click.stop="
												onHighlightAllFilesButtonClick(
													mailMeta[item],
													'PYHIGHLIGHT'
												)
											"
										>
											<v-icon color="cyan lighten-2" large
												>mdi-star-outline</v-icon
											>
										</v-btn>
									</template>
									<span>Highlight all files for this STOCKIST</span>
								</v-tooltip>
							</template>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn
										v-on="on"
										outline
										flat
										color="orange darken-3"
										class="show-on-parent-hover"
										@click.stop="
											revertFilesToMetaNotFound(mailMeta[item].map(e => e.uuid))
										"
										>Revert To Map</v-btn
									>
								</template>
								<span>Revert ALL files To Map Section</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn
										v-if="
											checkIfAnyFileContainsSpecifiedKey(
												mailMeta[item],
												'originalFileUUID'
											)
										"
										v-on="on"
										outline
										flat
										color="orange darken-3"
										class="show-on-parent-hover"
										@click.stop="revertFilesListToOrignal(mailMeta[item])"
										>Revert To Original</v-btn
									>
								</template>
								<span>Revert ALL converted files To Original</span>
							</v-tooltip>
						</span>
						<br />
						<span class="subheader" @click.right.prevent="copyToClipboard(item)"
							>Stockist Code: - {{ item }}</span
						>
						<br />
						<span class="subheader"
							>Files: - {{ mailMeta[item].length }} Files To Be Converted:
							{{ getFilesToBeConverted(mailMeta[item]).length }} Files
							Converted:
							{{ getFilesToBeConverted(mailMeta[item]).length }}</span
						>
					</div>
				</template>
				<v-card flat>
					<v-card-text>
						<v-list two-line subheader>
							<v-list-tile
								v-for="(file, i) in mailMeta[item]"
								:key="file._id"
								:class="{
									'expansion-panel-child': true,
									'are-all-files-converted': areAllFilesConverted([file]),
									'is-marked-for-conversion': areFilesMarkedForConversion([
										file,
									]),
								}"
								@click="openFileMetaModal(file)"
							>
								<v-list-tile-action>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<!-- <v-icon @click.stop="clearLock(file)" v-on="on">attach_file</v-icon> -->
											<v-icon @click.stop="clearLock(file)" v-on="on"
												>lock_open</v-icon
											>
										</template>
										<span>Clear Lock</span>
									</v-tooltip>
								</v-list-tile-action>
								<v-list-tile-content>
									<v-list-tile-title class="file-name-wrapper">
										<span
											@click.right.prevent="
												copyFileNameToClipboard(file.filename)
											"
										>
											{{ i + 1 }} Filename: -
											{{ file.filename }}
										</span>
										<div
											v-if="'isPythonScriptConvertable' in file"
											class="badge-circle"
											:class="{
												'green-badge': file.isPythonScriptConvertable,
											}"
										></div>
										<!-- <div
											v-if="file.isHighlighted"
											class="individual-file-badge amber lighten-2"
										>
											Highlighted
										</div>
										<div
											v-if="file.isPYHighlighted"
											class="individual-file-badge cyan lighten-2"
										>
											PY Highlighted
										</div> -->
									</v-list-tile-title>
									<v-list-tile-sub-title>
										<span
											@click.right.prevent="
												copyFileNameToClipboard(file.originalFilename)
											"
										>
											Original file name: -
											{{ file.originalFilename }}
										</span>
										<!-- <v-btn
											v-if="file.extension === 'pdf'"
											@click.stop="forceRejectFiles(file)"
											outline
											color="orange darken-1"
											small
											>REJECT FOR SPLIT</v-btn
										> -->
										<template v-if="file.isHighlighted">
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														class="ma-2"
														text
														icon
														@click.stop="onUnHighlightFileButtonClick(file)"
													>
														<v-icon color="amber lighten-2" large
															>mdi-star</v-icon
														>
													</v-btn>
												</template>
												<span>Unhighlight this file from the STOCKIST</span>
											</v-tooltip>
										</template>
										<template v-else>
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														class="ma-2"
														text
														icon
														@click.stop="onHighlightFileButtonClick(file)"
													>
														<v-icon color="amber lighten-2" large
															>mdi-star-outline</v-icon
														>
													</v-btn>
												</template>
												<span>Highlight this file from the STOCKIST</span>
											</v-tooltip>
										</template>
										<template v-if="file.isPYHighlighted">
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														class="ma-2"
														text
														icon
														@click.stop="
															onUnHighlightFileButtonClick(file, 'PYHIGHLIGHT')
														"
													>
														<v-icon color="cyan lighten-2" large
															>mdi-star</v-icon
														>
													</v-btn>
												</template>
												<span>Unhighlight this file from the STOCKIST</span>
											</v-tooltip>
										</template>
										<template v-else>
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														class="ma-2"
														text
														icon
														@click.stop="
															onHighlightFileButtonClick(file, 'PYHIGHLIGHT')
														"
													>
														<v-icon color="cyan lighten-2" large
															>mdi-star-outline</v-icon
														>
													</v-btn>
												</template>
												<span>Highlight this file from the STOCKIST</span>
											</v-tooltip>
										</template>
										<v-btn
											outline
											color="orange darken-1"
											small
											class="show-on-child-hover"
											@click.stop="revertFilesToMetaNotFound([file.uuid])"
											>Revert To Map</v-btn
										>
										<v-btn
											v-if="
												checkIfFileContainsSpecifiedKey(
													file,
													'originalFileUUID'
												)
											"
											outline
											color="orange darken-1"
											small
											class="show-on-child-hover"
											@click.stop="revertFileToOrignal(file)"
											>Revert To Original</v-btn
										>
									</v-list-tile-sub-title>
									<v-list-tile-sub-title>
										Remark: -
										{{ file.remarks[file.remarks.length - 1] }}
									</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-icon>keyboard_arrow_right</v-icon>
								</v-list-tile-action>
							</v-list-tile>
						</v-list>
					</v-card-text>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<div class="mt-1 mb-1 text-xs-center">
			<v-pagination
				color="yellow darken-3"
				prev-icon="navigate_before"
				next-icon="navigate_next"
				v-model="page"
				:total-visible="5"
				:length="paginationLength"
				@input="updatePage"
			></v-pagination>
		</div>
		<v-btn
			@click="refreshStockistList"
			color="pink"
			fab
			dark
			fixed
			small
			bottom
			right
		>
			<v-icon>autorenew</v-icon>
		</v-btn>
		<FileMetaModal v-if="fileMetaEditorDialog" />
	</div>
</template>

<script>
import FileMetaModal from './fileMetaModal';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import highlightMixins from '@/mixins/highlightMixins';
import clipboardCopyMixin from '@/mixins/clipboardCopyMixin';
import revertFilesMixin from '@/mixins/revertFilesMixin';

export default {
	mixins: [highlightMixins, clipboardCopyMixin, revertFilesMixin],
	data() {
		return {
			page: 1,
			paginationLength: 10,
			filterText: '',
			extension: false,
			remark: false,
			fileExtensions: [
				{ text: 'All', value: false },
				...require('../../components/extensions.json'),
			],
		};
	},
	components: {
		FileMetaModal,
	},
	created() {
		this.fetchMailMeta();
	},
	methods: {
		...mapActions('rejectedMetaTwo', [
			'getMailMeta',
			'lockFile',
			'unlockFile',
			'forceRejectFilesFromBackend',
		]),
		...mapMutations(['openSnackbar']),
		...mapMutations('rejectedMetaTwo', [
			'openFileMetaDialog',
			'setSelectedFile',
		]),
		...mapMutations(['openLoaderDialog', 'closeLoaderDialog']),
		openFileMetaModal(item) {
			this.lockFile(item._id).then(data => {
				if (!data) {
					this.setSelectedFile(item);
					this.openFileMetaDialog();
				} else {
					this.openSnackbar({
						text: 'File is being edited by someone else',
					});
				}
			});
		},
		fetchMailMeta() {
			this.openLoaderDialog();
			this.getMailMeta({
				pageNo: this.page,
				pageSize: 20,
				text: this.filterText,
				extension: this.extension,
				remark: this.remark,
				...this.getSelectedDates,
			}).then(data => {
				this.closeLoaderDialog();
				if (data) {
					// console.log(data);
					this.createHighlightedFilesRefrenceList(data.files);
					this.paginationLength = Math.ceil(data.length / 20);
					// console.log("Loaded mail meta");
				} else {
					console.log('Failed to load mail meta');
				}
			});
		},
		forceRejectFiles(file) {
			if (file.extension !== 'pdf') return;
			if (
				window.confirm(
					'Are you sure you want to REJECT FOR FORCE SPLIT this file'
				)
			) {
				this.openLoaderDialog();
				this.forceRejectFilesFromBackend({
					uuids: [file.uuid],
					additionalRemark: '[MULTI_PAGE_PDF]',
				})
					.then(data => {
						this.closeLoaderDialog();
						if (data) {
							this.refreshStockistList();
						} else {
							this.openSnackbar({
								text: 'Failed to reject files',
							});
						}
					})
					.catch(e => {
						this.closeLoaderDialog();
						this.openSnackbar({
							text: 'Failed to reject files',
						});
						this.refreshStockistList();
					});
			}
		},
		refreshStockistList() {
			// this.page = 1;
			this.filterText = '';
			// this.extension = false;
			this.fetchMailMeta();
		},
		updatePage() {
			this.fetchMailMeta();
		},
		filterStockist() {
			this.page = 1;
			this.fetchMailMeta();
		},
		clearLock(file) {
			this.unlockFile(file._id).then(data => {
				if (!data) {
					this.openSnackbar({
						text: 'Cleared File lock',
					});
				} else {
					this.openSnackbar({
						text: 'Could not clear file lock',
					});
				}
			});
		},
		getFilesToBeConverted(files = []) {
			return files.filter(e => {
				for (const remark of e.remarks) {
					if (
						remark.indexOf('[PYTHON_SCRIPT_CONVERTABLE]') > -1 ||
						remark.indexOf('[PDF_TABLES_CONVERTABLE]') > -1 ||
						remark.indexOf('[PYTHON_SCRIPT_DELIMITER_CONVERTABLE]') > -1 ||
						remark.indexOf('[PDF_ML_MODEL_HEADERS_CONVERTABLE]') > -1
					) {
						return true;
					}
				}

				return false;
			});
		},
		getFilesThatAreConverted(files = []) {
			return files.filter(e => {
				for (const remark of e.remarks) {
					if (remark.indexOf('[CONVERTED_FILE]') > -1) {
						return true;
					}
				}

				return false;
			});
		},
		areAllFilesConverted(files) {
			const FilesToBeConverted = this.getFilesToBeConverted(files);
			const FilesThatAreConverted = this.getFilesThatAreConverted(files);
			if (FilesToBeConverted.length == 0 && FilesThatAreConverted.length == 0) {
				return false;
			}

			if (FilesToBeConverted.length == FilesThatAreConverted.length) {
				return true;
			}

			return false;
		},
		areFilesMarkedForConversion(files) {
			const FilesToBeConverted = this.getFilesToBeConverted(files);
			const FilesThatAreConverted = this.getFilesThatAreConverted(files);
			if (FilesToBeConverted.length == 0 && FilesThatAreConverted.length == 0) {
				return false;
			}

			if (FilesToBeConverted.length !== FilesThatAreConverted.length) {
				return true;
			}

			return false;
		},
		fetchDataAfterAPICall() {
			this.fetchMailMeta();
		},
	},
	computed: {
		...mapGetters(['getSelectedDates', 'selectedDates', 'rejectRemarks']),
		...mapGetters('rejectedMetaTwo', ['fileMetaEditorDialog', 'mailMeta']),
		getFileCount() {
			let count = 0;
			for (let i in this.mailMeta) {
				count += this.mailMeta[i].length;
			}
			return count;
		},
	},
	mounted() {
		this.$store.subscribe((mutation, state) => {
			if (mutation.type === 'rejectedMetaTwo/refreshStockistListEmitter') {
				this.refreshStockistList();
			}
		});
	},
	watch: {
		selectedDates(nv, cv) {
			this.refreshStockistList();
		},
	},
};
</script>

<style lang="scss" scoped>
.are-all-files-converted {
	background: #c8e6c9 !important;
}
.is-marked-for-conversion {
	background: #ffcdd2 !important;
}
.v-pagination >>> li button {
	width: 100%;
	min-width: 35px;
}
.v-card__text {
	padding: 0px;
}
.headline {
	position: relative;

	.badge-list-wrapper {
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
	}

	.highlight-badge {
		transform: translateY(-90%);
		font-size: 12px;
		line-height: 1;
		padding: 4px 8px;
		border-radius: 500px;
		margin-right: 6px;

		&.all-highlighted {
			background-color: #31c8ee;
		}
		&.some-highlighted {
			background-color: #ff7043;
		}
	}
}
.file-name-wrapper {
	display: flex;
	align-items: center;

	.individual-file-badge {
		font-size: 12px;
		line-height: 1;
		margin-left: 8px;
		padding: 4px 8px;
		border-radius: 500px;
		background-color: #31c8ee;
	}
}
</style>
